<template>
    <!-- App -->
    <div id="app">

        <!-- Statusbar -->
        <f7-statusbar></f7-statusbar>

        <!-- Right Panel -->
        <f7-panel right cover layout="dark">
            <f7-view id="right-panel-view" navbar-through :dynamic-navbar="true">
                <f7-pages>
                    <f7-page>

                        <v-sidebar :items="links"></v-sidebar>

                    </f7-page>
                </f7-pages>
            </f7-view>
        </f7-panel>

        <f7-views>
            <f7-view id="main-view" navbar-through :dynamic-navbar="true" main>
                <f7-pages>
                    <f7-page>
                        <f7-navbar :title="title" sliding>
                            <f7-nav-right>
                                <f7-link icon="icon-bars" open-panel="left"></f7-link>
                            </f7-nav-right>
                        </f7-navbar>

                        <v-cpanel-icons :items="links"></v-cpanel-icons>


                        <!-- Popup certificate_inquiry_form -->
                        <f7-popup class="certificate_inquiry_form">
                            <f7-navbar :title="$root.__('Certificate Inquiry')"></f7-navbar>

                            <f7-block>
                                <f7-list form>
                                    <f7-list-item>
                                        <f7-label>{{ $root.__('National Code') }}</f7-label>
                                        <f7-input v-model="certificate_inquiry.national_code"
                                                  @input="onNationalCodeChange"
                                                  type="text" :placeholder="$root.__('National Code')" />
                                    </f7-list-item>
                                </f7-list>
                                <f7-grid>
                                    <f7-col>
                                        <f7-button
                                                :class="certificate_inquiry.national_code ? '' : 'disabled'"
                                                raised fill color="blue"
                                                @click="certificateInquiry">{{ $root.__('Inquiry') }}</f7-button>
                                    </f7-col>
                                    <f7-col>
                                        <f7-button raised fill color="orange" close-popup>{{ $root.__('Cancel') }}</f7-button>
                                    </f7-col>
                                    <f7-col></f7-col>
                                </f7-grid>

                                <div class="certificate_image">
                                    <f7-card v-if="certificates && certificates.length === 0" class="alert-danger">
                                        <f7-card-content>{{ $root.__('No certificate found whit this code "%s"!', certificate_inquiry.national_code) }}</f7-card-content>
                                    </f7-card>
                                    <slot v-else>
                                        <slot v-if="certificates && certificates.length > 0">
                                            <f7-grid>
                                                <f7-col v-for="certificate in certificates" :key="certificate.id" width="50" tablet-width="25">
                                                    <a href="#" @click="zoomOnCertificate(certificate)">
                                                        <img :src="certificate.thumbnail_image" />
                                                    </a>
                                                </f7-col>
                                            </f7-grid>
                                        </slot>
                                    </slot>
                                </div>

                            </f7-block>
                        </f7-popup>
                        <!-- Popup certificate_inquiry_form -->

                        <!-- Popup certificate for zooming -->
                        <f7-popup class="certificate_zoom">
                            <f7-block>
                                <div class="certificate_image">
                                    <img v-if="certificate" :src="certificate.image" />
                                </div>

                                <f7-grid>
                                    <f7-col></f7-col>
                                    <f7-col>
                                        <f7-button raised fill color="blue"
                                                   @click="closeZoomCertificate">{{ $root.__('Close') }}</f7-button>
                                    </f7-col>
                                    <f7-col></f7-col>
                                </f7-grid>
                            </f7-block>
                        </f7-popup>
                        <!-- Popup certificate for zooming -->

                    </f7-page>
                </f7-pages>
            </f7-view>
        </f7-views>

    </div>
</template>

<script>
    import VCpanelIcons from './components/VCpanelIcons';
    import VSidebar from './components/VSidebar';

    export default {
        components: {VCpanelIcons, VSidebar},

        data: function () {
            let self = this;

            return {
                title: self.$root.__('Application Name'),
                certificate_inquiry: {
                    national_code: '',
                },
                certificates: null,
                certificate: null,
                links: [
                    {
                        label: self.$root.__('Certificate Inquiry'),
                        link: '#',
                        icon: 'icon1',
                        color: 'indigo',
                        onClick: function () {
                            self.showCertificateInquiryForm();
                        }
                    },
                    {
                        name: 'exit',
                        label: self.$root.__('Return to Site'),
                        link: '#',
                        icon: 'icon2',
                        color: 'indigo',
                        onClick: function () {
                            self.returnToSite();
                        }
                    },
                ]
            }
        },
        computed: {

        },
        methods: {
            closeZoomCertificate: function () {
                this.$f7.closeModal('.certificate_zoom');
            },
            zoomOnCertificate: function (certificate) {
                let self = this;

                self.certificate = certificate;
                self.$f7.popup('.certificate_zoom');
            },
            returnToSite: function () {
                let self = this;

                window.location = self.$store.state._wordpress_url;
            },
            showCertificateInquiryForm: function () {
                let self = this;

                self.$f7.popup('.certificate_inquiry_form');
            },
            certificateInquiry: function () {
                let self = this;

                self.$f7.showIndicator();
                self.axios.post(self.$store.state._ajax_url + 'guest/certificateinquiry', self.certificate_inquiry)
                    .then(function (response) {
                        if (response.data.length === 0)
                            self.certificates = [];
                        else
                            self.certificates = response.data;

                        self.$f7.hideIndicator();
                    })
                    .catch(function (error) {
                        self.certificates = [];
                        
                        self.$f7.hideIndicator();
                    });
            },
            onNationalCodeChange: function () {
                let self = this;

                self.certificates = null;
            }
        },
        mounted: function () {
            let self = this;

            window.setTimeout(function () {
                let ls = JSON.parse(localStorage.getItem('mftsk-lms')) || {};
                if (ls.redirect && ls.redirect !== '') {
                    self.$f7.mainView.loadPage(ls.redirect);
                }
            }, 1000);

            window.TEST = this;
        }
    }
</script>


// WEBPACK FOOTER //
// app.vue?4d38a2f7